const V2_PREFIX = 'v2:';
const IV_LEN = 12;
const TAG_LEN = 16;

function base64ToUint8Array(base64) {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
}

async function deriveKey(passphrase) {
    const hash = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(passphrase));
    return crypto.subtle.importKey('raw', hash, { name: 'AES-GCM' }, false, ['decrypt']);
}

async function decryptV2(encryptedValue, passphrase) {
    const payload = base64ToUint8Array(encryptedValue);
    if (payload.length < IV_LEN + TAG_LEN) {
        throw new Error('decryptV2: payload too short');
    }

    const iv = payload.slice(0, IV_LEN);
    const ciphertextAndTag = payload.slice(IV_LEN);
    const key = await deriveKey(passphrase);
    const decrypted = await crypto.subtle.decrypt({ name: 'AES-GCM', iv, tagLength: 128 }, key, ciphertextAndTag);

    return new TextDecoder().decode(decrypted);
}

export async function decryptWithKey(value, passphrase) {
    if (!value) return value;
    if (!passphrase) throw new Error('decryptWithKey: passphrase is required');
    if (!value.startsWith(V2_PREFIX)) throw new Error('Only v2 format is supported');

    return decryptV2(value.slice(V2_PREFIX.length), passphrase);
}
